import * as React from "react";
import { Grid } from "@mui/material";
import Breadcrumbs from "../../containers/Breadcrumbs";
import ReturnToLandingPageButton from "../../containers/ReturnToLandingPageButton";
import BackButton from "../../containers/BackButton";
import HelpButton from "../HelpContent/HelpButton";
import FinancialReportDetailsSearchForm from "../../containers/FinancialReportDetailsSearchForm";
import { AppUrl } from "../../config";
import CloudFoundryBanner from "../../containers/CloudFoundryBanner";

export default function DefineCustomReport() {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={11}>
          <Breadcrumbs currentPageBreadCrumbTitle="Define Custom Peer Groups" />
        </Grid>
        <Grid item xs={1}>
          <HelpButton />
        </Grid>
      </Grid>
      <CloudFoundryBanner />
      <ReturnToLandingPageButton />
      <BackButton
        app="FinancialReporting"
        buttonLabel="Back to Financial Reporting"
        variant="dark"
      />
      <FinancialReportDetailsSearchForm
        data={[{}]}
        fromLevelOne={false}
        customVariant
        returnPath={`${AppUrl("PeerGroup")}/manage?reloadReports=true`}
      />
    </>
  );
}
